import { request } from "@/util/request.js"

export function getBaiduAIAnswer(data){
  return request({
    method: 'post',
    url: '/baidu/ai/call',
    data
  })
}

// 流式
export function getAIAnswerV2(data){
  return request({
    method: 'post',
    url: '/mendao/ai/v2/callStream',
    responseType: 'stream',
    data
  })
}

export function queryAIChatList(data){
  return request({
    method: 'get',
    url: '/mendao/ai/chatList',
    data
  })
}

export function updateBaiduAIChatTitle(data){
  return request({
    method: 'post',
    url: '/mendao/ai/updateChatTitle',
    data
  })
}

export function deleteBaiduAIChat(data){
  return request({
    method: 'post',
    url: '/mendao/ai/deleteChat',
    data
  })
}
